import useAppModal from 'hooks/useAppModal';
import { useTranslation } from 'react-i18next';
import { UnitListSchemaType } from '../PropertySettingsUnitsTab.schema';
import useUnitManagement from '../useUnitManagement';
import ModalAlertBody from './ModalAlertBody';

const useDeleteConfirmationModal = (
  unit: NonNullable<UnitListSchemaType['units']>[number],
) => {
  const { t } = useTranslation();
  const { openConfirmModal } = useAppModal();
  const { deleteUnit } = useUnitManagement();

  const openDeleteConfirmationModal = () => {
    if (unit.isTemporary) {
      deleteUnit(unit.uid);
      return;
    }

    openConfirmModal({
      title: t('pageProperty.units.modals.title'),
      body: <ModalAlertBody type="delete" unit={unit} />,
      confirmColor: 'danger',
      confirmLabel: t('common.delete'),
      onConfirm: () => {
        deleteUnit(unit.uid);
      },
    });
  };

  return { openDeleteConfirmationModal };
};

export default useDeleteConfirmationModal;
